import { UiName, FieldMap } from "../../shared/types";
import { Aanleiding } from "../../.generated/forms/formstypes";
import { target2field } from "../../shared/utils/target-to-field";

export function mapAanleidingDlTargetToUiField(target: string): UiName | null {
  const map: FieldMap<Aanleiding> = {};

  return target2field(map, target);
}
